// prettier-ignore
import { type ProctorSpecification } from '../../../shared/proctor/ProctorSpecification';

export const AfsauthRajRequireLoginTst = {
    name: 'afsauth_raj_require_login_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type AfsauthRajRequireLoginTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const BrandedjobMigrationRnvjTst = {
    name: 'brandedjob_migration_rnvj_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        Shadow: 2,
    },
} satisfies ProctorSpecification;

export type BrandedjobMigrationRnvjTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isShadow: boolean;
};

export const CareerScoutAlwaysAware = {
    name: 'career_scout_always_aware',
    buckets: {
        Inactive: -1,
        Control: 0,
        Matchsection: 1,
        Separate: 2,
        Scroll: 3,
        Ask: 4,
    },
} satisfies ProctorSpecification;

export type CareerScoutAlwaysAwareAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isMatchsection: boolean;
    isSeparate: boolean;
    isScroll: boolean;
    isAsk: boolean;
};

export const CareerScoutDynamicConvoStartersVjTst = {
    name: 'career_scout_dynamic_convo_starters_vj_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type CareerScoutDynamicConvoStartersVjTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const CareerScoutStartersRandomOrderingVjTog = {
    name: 'career_scout_starters_random_ordering_vj_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type CareerScoutStartersRandomOrderingVjTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const DiscoLimitedUiTst = {
    name: 'disco_limited_ui_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type DiscoLimitedUiTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const G4jExpiredVjRecommendedJobsTst = {
    name: 'g4j_expired_vj_recommended_jobs_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
        All: 2,
    },
} satisfies ProctorSpecification;

export type G4jExpiredVjRecommendedJobsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
    isAll: boolean;
};

export const HeRnViewjobOverviewTst = {
    name: 'he_rn_viewjob_overview_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type HeRnViewjobOverviewTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const IaBrandedApplyButtonRnTst = {
    name: 'ia_branded_apply_button_rn_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type IaBrandedApplyButtonRnTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JcsReportJobTst = {
    name: 'jcs_report_job_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type JcsReportJobTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const JmRnReusablePayComponentTst = {
    name: 'jm_rn_reusable_pay_component_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type JmRnReusablePayComponentTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JsjPostApplyAdTst = {
    name: 'jsj_post_apply_ad_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
        Testingonly: 2,
    },
} satisfies ProctorSpecification;

export type JsjPostApplyAdTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
    isTestingonly: boolean;
};

export const JsjRnCompanyTabTst = {
    name: 'jsj_rn_company_tab_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type JsjRnCompanyTabTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const JsjRnMobVjOffsiteW2aPromoTst = {
    name: 'jsj_rn_mob_vj_offsite_w2a_promo_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type JsjRnMobVjOffsiteW2aPromoTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const JsoSaveJobGateTst = {
    name: 'jso_save_job_gate_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type JsoSaveJobGateTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JsoStructuredLocationValidationTst = {
    name: 'jso_structured_location_validation_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        StructuredValidation: 1,
    },
} satisfies ProctorSpecification;

export type JsoStructuredLocationValidationTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isStructuredValidation: boolean;
};

export const MapExternalApplyMigrateTst = {
    name: 'map_external_apply_migrate_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type MapExternalApplyMigrateTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const MegAccelPostThirdpartyApplyPushPrimerTst = {
    name: 'meg_accel_post_thirdparty_apply_push_primer_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type MegAccelPostThirdpartyApplyPushPrimerTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const MegOffsiteJobalertRnvjTst = {
    name: 'meg_offsite_jobalert_rnvj_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type MegOffsiteJobalertRnvjTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const MobVjApplyRateLimitTst = {
    name: 'mob_vj_apply_rate_limit_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type MobVjApplyRateLimitTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const MobVjCommutePrefTst = {
    name: 'mob_vj_commute_pref_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
    },
} satisfies ProctorSpecification;

export type MobVjCommutePrefTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
};

export const MobVjCompanyConquestingTst = {
    name: 'mob_vj_company_conquesting_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
        Grp5: 5,
    },
} satisfies ProctorSpecification;

export type MobVjCompanyConquestingTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
    isGrp5: boolean;
};

export const MobVjJobSummaryTst = {
    name: 'mob_vj_job_summary_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
        Grp5: 5,
    },
} satisfies ProctorSpecification;

export type MobVjJobSummaryTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
    isGrp5: boolean;
};

export const MobVjMatchOverviewA11yListTog = {
    name: 'mob_vj_match_overview_a11y_list_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type MobVjMatchOverviewA11yListTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const MobVjMatchOverviewResumeGateTst = {
    name: 'mob_vj_match_overview_resume_gate_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type MobVjMatchOverviewResumeGateTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const MobVjMatchOverviewTst = {
    name: 'mob_vj_match_overview_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type MobVjMatchOverviewTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const MobVjMatchQualificationA11yLabel = {
    name: 'mob_vj_match_qualification_a11y_label',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type MobVjMatchQualificationA11yLabelAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const NexusJobSeekerDisclaimer = {
    name: 'nexus_job_seeker_disclaimer',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        Showaccommodation: 2,
    },
} satisfies ProctorSpecification;

export type NexusJobSeekerDisclaimerAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isShowaccommodation: boolean;
};

export const RajMoreTextExp = {
    name: 'raj_more_text_exp',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type RajMoreTextExpAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const RnEmployerOutreachTst = {
    name: 'rn_employer_outreach_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Test: 2,
    },
} satisfies ProctorSpecification;

export type RnEmployerOutreachTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isTest: boolean;
};

export const RnJsProMobVjEmpInsightsTst = {
    name: 'rn_js_pro_mob_vj_emp_insights_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type RnJsProMobVjEmpInsightsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const RnJsProVjProInsightsTog = {
    name: 'rn_js_pro_vj_pro_insights_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnJsProVjProInsightsTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnMosaicProviderJsPremiumApplicantInsightsTog = {
    name: 'rn_mosaic_provider_js_premium_applicant_insights_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        Mock: 2,
    },
} satisfies ProctorSpecification;

export type RnMosaicProviderJsPremiumApplicantInsightsTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isMock: boolean;
};

export const RnMosaicProviderProBannerVjTog = {
    name: 'rn_mosaic_provider_pro_banner_vj_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
        ActivePremium: 2,
        CtaVariant1: 3,
        CtaVariant2: 4,
        CtaVariant3: 5,
        CtaVariant4: 6,
        CtaVariant5: 7,
        CtaVariant6: 8,
        TeaseInsightsVariant1: 9,
        TeaseInsightsVariant2: 10,
        TeaseInsightsVariant3: 11,
        VisualDesignVariant1: 12,
        VisualDesignVariant2: 13,
        VisualDesignVariant3: 14,
        VisualDesignVariant4: 15,
        VisualDesignCtrl: 16,
        VisualDesignRandom: 17,
    },
} satisfies ProctorSpecification;

export type RnMosaicProviderProBannerVjTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
    isActivePremium: boolean;
    isCtaVariant1: boolean;
    isCtaVariant2: boolean;
    isCtaVariant3: boolean;
    isCtaVariant4: boolean;
    isCtaVariant5: boolean;
    isCtaVariant6: boolean;
    isTeaseInsightsVariant1: boolean;
    isTeaseInsightsVariant2: boolean;
    isTeaseInsightsVariant3: boolean;
    isVisualDesignVariant1: boolean;
    isVisualDesignVariant2: boolean;
    isVisualDesignVariant3: boolean;
    isVisualDesignVariant4: boolean;
    isVisualDesignCtrl: boolean;
    isVisualDesignRandom: boolean;
};

export const RnViewjobOnegraphTst = {
    name: 'rn_viewjob_onegraph_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Aa: 1,
        Test: 2,
    },
} satisfies ProctorSpecification;

export type RnViewjobOnegraphTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isAa: boolean;
    isTest: boolean;
};

export const RnViewjobStickyApplyBtnTst = {
    name: 'rn_viewjob_sticky_apply_btn_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnViewjobStickyApplyBtnTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnVjJrsFieldsTst = {
    name: 'rn_vj_jrs_fields_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnVjJrsFieldsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpParentTest = {
    name: 'rnhp_parent_test',
    buckets: {
        Inactive: -1,
        WebAllocation: 0,
        Control: 1,
        ControlAa: 2,
        Active: 3,
        ReserveA: 4,
        ReserveB: 5,
        ReserveC: 6,
        ReserveD: 7,
        ReserveE: 8,
        ReserveF: 9,
        ReserveG: 10,
    },
} satisfies ProctorSpecification;

export type RnhpParentTestAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isWebAllocation: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
    isReserveA: boolean;
    isReserveB: boolean;
    isReserveC: boolean;
    isReserveD: boolean;
    isReserveE: boolean;
    isReserveF: boolean;
    isReserveG: boolean;
};

export const RnhpVj = {
    name: 'rnhp_vj',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
        Grp5: 5,
    },
} satisfies ProctorSpecification;

export type RnhpVjAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
    isGrp5: boolean;
};

export type ViewjobProctorSpecification =
    | typeof AfsauthRajRequireLoginTst
    | typeof BrandedjobMigrationRnvjTst
    | typeof CareerScoutAlwaysAware
    | typeof CareerScoutDynamicConvoStartersVjTst
    | typeof CareerScoutStartersRandomOrderingVjTog
    | typeof DiscoLimitedUiTst
    | typeof G4jExpiredVjRecommendedJobsTst
    | typeof HeRnViewjobOverviewTst
    | typeof IaBrandedApplyButtonRnTst
    | typeof JcsReportJobTst
    | typeof JmRnReusablePayComponentTst
    | typeof JsjPostApplyAdTst
    | typeof JsjRnCompanyTabTst
    | typeof JsjRnMobVjOffsiteW2aPromoTst
    | typeof JsoSaveJobGateTst
    | typeof JsoStructuredLocationValidationTst
    | typeof MapExternalApplyMigrateTst
    | typeof MegAccelPostThirdpartyApplyPushPrimerTst
    | typeof MegOffsiteJobalertRnvjTst
    | typeof MobVjApplyRateLimitTst
    | typeof MobVjCommutePrefTst
    | typeof MobVjCompanyConquestingTst
    | typeof MobVjJobSummaryTst
    | typeof MobVjMatchOverviewA11yListTog
    | typeof MobVjMatchOverviewResumeGateTst
    | typeof MobVjMatchOverviewTst
    | typeof MobVjMatchQualificationA11yLabel
    | typeof NexusJobSeekerDisclaimer
    | typeof RajMoreTextExp
    | typeof RnEmployerOutreachTst
    | typeof RnJsProMobVjEmpInsightsTst
    | typeof RnJsProVjProInsightsTog
    | typeof RnMosaicProviderJsPremiumApplicantInsightsTog
    | typeof RnMosaicProviderProBannerVjTog
    | typeof RnViewjobOnegraphTst
    | typeof RnViewjobStickyApplyBtnTst
    | typeof RnVjJrsFieldsTst
    | typeof RnhpParentTest
    | typeof RnhpVj;

export type ViewjobProctorAllocation =
    | AfsauthRajRequireLoginTstAllocation
    | BrandedjobMigrationRnvjTstAllocation
    | CareerScoutAlwaysAwareAllocation
    | CareerScoutDynamicConvoStartersVjTstAllocation
    | CareerScoutStartersRandomOrderingVjTogAllocation
    | DiscoLimitedUiTstAllocation
    | G4jExpiredVjRecommendedJobsTstAllocation
    | HeRnViewjobOverviewTstAllocation
    | IaBrandedApplyButtonRnTstAllocation
    | JcsReportJobTstAllocation
    | JmRnReusablePayComponentTstAllocation
    | JsjPostApplyAdTstAllocation
    | JsjRnCompanyTabTstAllocation
    | JsjRnMobVjOffsiteW2aPromoTstAllocation
    | JsoSaveJobGateTstAllocation
    | JsoStructuredLocationValidationTstAllocation
    | MapExternalApplyMigrateTstAllocation
    | MegAccelPostThirdpartyApplyPushPrimerTstAllocation
    | MegOffsiteJobalertRnvjTstAllocation
    | MobVjApplyRateLimitTstAllocation
    | MobVjCommutePrefTstAllocation
    | MobVjCompanyConquestingTstAllocation
    | MobVjJobSummaryTstAllocation
    | MobVjMatchOverviewA11yListTogAllocation
    | MobVjMatchOverviewResumeGateTstAllocation
    | MobVjMatchOverviewTstAllocation
    | MobVjMatchQualificationA11yLabelAllocation
    | NexusJobSeekerDisclaimerAllocation
    | RajMoreTextExpAllocation
    | RnEmployerOutreachTstAllocation
    | RnJsProMobVjEmpInsightsTstAllocation
    | RnJsProVjProInsightsTogAllocation
    | RnMosaicProviderJsPremiumApplicantInsightsTogAllocation
    | RnMosaicProviderProBannerVjTogAllocation
    | RnViewjobOnegraphTstAllocation
    | RnViewjobStickyApplyBtnTstAllocation
    | RnVjJrsFieldsTstAllocation
    | RnhpParentTestAllocation
    | RnhpVjAllocation;

export const ViewjobProctorSpecifications = [
    AfsauthRajRequireLoginTst,
    BrandedjobMigrationRnvjTst,
    CareerScoutAlwaysAware,
    CareerScoutDynamicConvoStartersVjTst,
    CareerScoutStartersRandomOrderingVjTog,
    DiscoLimitedUiTst,
    G4jExpiredVjRecommendedJobsTst,
    HeRnViewjobOverviewTst,
    IaBrandedApplyButtonRnTst,
    JcsReportJobTst,
    JmRnReusablePayComponentTst,
    JsjPostApplyAdTst,
    JsjRnCompanyTabTst,
    JsjRnMobVjOffsiteW2aPromoTst,
    JsoSaveJobGateTst,
    JsoStructuredLocationValidationTst,
    MapExternalApplyMigrateTst,
    MegAccelPostThirdpartyApplyPushPrimerTst,
    MegOffsiteJobalertRnvjTst,
    MobVjApplyRateLimitTst,
    MobVjCommutePrefTst,
    MobVjCompanyConquestingTst,
    MobVjJobSummaryTst,
    MobVjMatchOverviewA11yListTog,
    MobVjMatchOverviewResumeGateTst,
    MobVjMatchOverviewTst,
    MobVjMatchQualificationA11yLabel,
    NexusJobSeekerDisclaimer,
    RajMoreTextExp,
    RnEmployerOutreachTst,
    RnJsProMobVjEmpInsightsTst,
    RnJsProVjProInsightsTog,
    RnMosaicProviderJsPremiumApplicantInsightsTog,
    RnMosaicProviderProBannerVjTog,
    RnViewjobOnegraphTst,
    RnViewjobStickyApplyBtnTst,
    RnVjJrsFieldsTst,
    RnhpParentTest,
    RnhpVj,
];